import MPoint from "../models/metMap/mPoint";
export default class MPointMapper {
    //public static flattenMPointTree(treeRoot: MPoint): Array<MPoint> {
    //    const mPointList = new Array<MPoint>();
    //    this.flattenNode(treeRoot, mPointList);
    //    return mPointList;
    //}
    //private static flattenNode(treeNode: MPoint, list: Array<MPoint>) {
    //    list.push(treeNode);
    //    treeNode.children.forEach(child => { this.flattenNode(child, list); });
    //}
    //public static parseRawTree(rawNode: any, parent?: MPoint): MPoint {
    //    const mPoint = new MPoint();
    //    mPoint.id = rawNode.id;
    //    mPoint.name = rawNode.name;
    //    mPoint.parent = parent;
    //    mPoint.lat = rawNode.lat;
    //    mPoint.long = rawNode.long;
    //    mPoint.isFolder = rawNode.isFolder;
    //    mPoint.unom = rawNode.unom;
    //    if (rawNode.norm)
    //        mPoint.norm = NormMapper.mapNorm(rawNode.norm);
    //    if (rawNode.pQ4castSettings)
    //        mPoint.limits = PQ4castMpointSettingsMapper.mapLimits(rawNode.pQ4castSettings);
    //    const children = rawNode.children.map(rawChild => { return this.parseRawTree(rawChild, mPoint) });
    //    mPoint.children = children;
    //    return mPoint;
    //}
    static parse(rawNode, parent) {
        var _a, _b;
        const mPoint = new MPoint();
        mPoint.id = rawNode.mpointId;
        mPoint.name = rawNode.name;
        mPoint.lat = rawNode.latitude;
        mPoint.long = rawNode.longitude;
        mPoint.pqStatus = rawNode.status;
        mPoint.notificationStatus = rawNode.notificationStatus;
        mPoint.stationType = rawNode.stationType;
        mPoint.hullId = (_b = (_a = rawNode.hullFolder) === null || _a === void 0 ? void 0 : _a.treeNodeId) !== null && _b !== void 0 ? _b : null;
        return mPoint;
    }
}
